interface IProps {
  content: any;
}

const Site = ({ content }: IProps) => {
  return content;
};

export default Site;
